import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTriangleExclamation} from "@fortawesome/pro-solid-svg-icons";
import ConfirmDialog, {ConfirmDialogProps} from "../confirm-dialog";

export interface WarningDialogProps extends Omit<ConfirmDialogProps, 'confirmButtonVariant' | 'confirmLabel' | 'cancelLabel' | 'logo'> {
    confirmLabel?: string;
    cancelLabel?: string;
}

const WarningDialog: React.FC<WarningDialogProps> = ({
         open,
         onConfirm,
         onCancel,
         message,
         title,
         confirmLabel = "Confirmer",
         cancelLabel = "Annuler",
     }) => (
        <ConfirmDialog
        open={open}
        onConfirm={onConfirm}
        onCancel={onCancel}
        title={title}
        message={message}
        confirmLabel={confirmLabel}
        cancelLabel={cancelLabel}

        logo={
            <FontAwesomeIcon icon={faTriangleExclamation} className='text-yellow-400 text-5xl'/>
         }
        confirmButtonVariant='warning'
    />
);

export default WarningDialog;
